import { render, staticRenderFns } from "./GoodsChange.vue?vue&type=template&id=08f74ef5&scoped=true&"
import script from "./GoodsChange.vue?vue&type=script&lang=js&"
export * from "./GoodsChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f74ef5",
  null
  
)

export default component.exports